import * as t from "io-ts";

export const codec = t.type({
    id: t.string,
    first_name: t.string,
    last_name: t.string,
});

export type T = t.TypeOf<typeof codec>;

export const fullName = (seller: T): string =>
    `${seller.first_name} ${seller.last_name}`.trim();

export const namesToString = (sellers: Array<T>): string =>
    sellers.map(fullName).filter((name) => name !== "").join(" & ");
